import { Formik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLocalized } from "../../redux/localization";
import { Model } from "../../redux/cars/types/model";
import { CarLookup } from "../../redux/cars/types/carLookup";
import { getBrandDetail, getFilterCarList } from "../../redux/cars";
import { Button } from "../../components";
import { ButtonType } from "../../components/button";
import { Drawer, SelectPicker } from "rsuite";
import { Row } from "reactstrap";
import { Car } from "../../redux/cars/types/car";
import CustomLoader from "../../components/loader";
const selectPickerWidth = { width: "100%", marginBlockEnd: 20 };

type FilterType = {
  brand: string;
  model: string;
  bodyType: string;
  fuelType: string;
  gearType: string;
};
const ResponsiveFilterDrawer = ({
  carlookup,
  models,
  setModels,
  setCars,
  setPageNumber,
}: {
  setPageNumber: (i: number) => void;
  carlookup?: CarLookup;
  models: Model[];
  setCars: (cars: Car[]) => void;
  setModels: (models: Model[]) => void;
}) => {
  const dispatch = useDispatch();
  const localize = useSelector(getLocalized);
  const ValidationSchema = Yup.object().shape({});
  const [loader, setLoader] = useState(false);
  const onSubmitPress = ({
    brand,
    model,
    bodyType,
    fuelType,
    gearType,
  }: FilterType) => {
    const _brand = brand === "" ? undefined : brand;
    const _model = model === "" ? undefined : model;
    const _bodyType = bodyType === "" ? undefined : bodyType;
    const _fuelType = fuelType === "" ? undefined : fuelType;
    const _gearType = gearType === "" ? undefined : gearType;

    let path = `?brand=${_brand}&model=${_model}&bodyType=${_bodyType}&gearType=${_gearType}&fuelType=${_fuelType}`;
    setLoader(true);
    dispatch(
      getFilterCarList({
        payload: {
          onSuccess: (message, payload) => {
            setCars(payload);
            setShow(false);
            setLoader(false);
            setPageNumber(1);
          },
          onError: (message) => {},
        },
        url: "api/car/filter" + path,
      })
    );
  };

  const [show, setShow] = useState<boolean>(false);

  return (
    <div className="responsiveFiltre">
      <div
        className="py-2"
        style={{
          bottom: "0px",
          position: "fixed",
          zIndex: "1035",
          width: "100%",
          backgroundColor: "#ff4436",
          color: "white",
          fontSize: 22,
          fontWeight: 700,
          fontFamily: "DIN Pro Cond",
          textAlign: "center",
        }}
        onClick={() => setShow(true)}
      >
        FİLTRE
      </div>
      <Drawer
        placement="bottom"
        open={show}
        onClose={() => {
          setShow(false);
        }}
      >
        <Drawer.Body>
          <Formik
            initialValues={{
              brand: "",
              model: "",
              bodyType: "",
              fuelType: "",
              gearType: "",
            }}
            validationSchema={ValidationSchema}
            onSubmit={onSubmitPress}
          >
            {({ handleSubmit, values, errors, touched }) => {
              return (
                <>
                  {loader && <CustomLoader />}
                  <Row>
                    <SelectPicker
                      data={carlookup?.Brands ? carlookup?.Brands : []}
                      placement="topStart"
                      cleanable={false}
                      style={selectPickerWidth}
                      placeholder={localize.getString("brand")}
                      labelKey="BrandName"
                      valueKey="Id"
                      onSelect={(e, item) => {
                        dispatch(
                          getBrandDetail({
                            payload: {
                              onSuccess: (message, payload) => {
                                setModels(payload.CarModels);
                                values.brand = e;
                              },
                              onError: (message) => {},
                            },
                            url: "api/car/definitions/brand/" + item.Id,
                          })
                        );
                      }}
                    />
                    <SelectPicker
                      data={models}
                      cleanable={false}
                      placement="topStart"
                      style={selectPickerWidth}
                      placeholder={localize.getString("model")}
                      labelKey="ModelName"
                      valueKey="Id"
                      onSelect={(value) => (values.model = value)}
                    />
                    <SelectPicker
                      data={carlookup?.BodyTypes ? carlookup?.BodyTypes : []}
                      placement="topStart"
                      style={selectPickerWidth}
                      placeholder={localize.getString("bodytype")}
                      labelKey="Name"
                      cleanable={false}
                      valueKey="Id"
                      onSelect={(value) => (values.bodyType = value)}
                    />
                    <SelectPicker
                      data={carlookup?.FuelTypes ? carlookup?.FuelTypes : []}
                      placement="topStart"
                      cleanable={false}
                      style={selectPickerWidth}
                      placeholder={localize.getString("fueltype")}
                      labelKey="Name"
                      valueKey="Id"
                      onSelect={(value) => (values.fuelType = value)}
                    />
                    <SelectPicker
                      data={carlookup?.GearTypes ? carlookup?.GearTypes : []}
                      placement="topStart"
                      style={selectPickerWidth}
                      cleanable={false}
                      placeholder={localize.getString("geartype")}
                      labelKey="Name"
                      valueKey="Id"
                      onSelect={(value) => (values.gearType = value)}
                    />

                    <div className="d-flex justify-content-center">
                      <Button
                        type="submit"
                        title={localize.getString("filter")}
                        buttonType={ButtonType.newColored}
                        style={{
                          width: "100%",
                          fontWeight: 700,
                          fontSize: 20,
                          marginBlock: 10,
                          marginInlineEnd: 10,
                        }}
                        onClick={handleSubmit}
                      />
                    </div>
                  </Row>
                </>
              );
            }}
          </Formik>
        </Drawer.Body>
      </Drawer>
    </div>
  );
};
export default ResponsiveFilterDrawer;
